import React, { useEffect, useState, useCallback, useRef } from "react";
import { saveAs } from 'file-saver';
import { Line } from "react-chartjs-2";
import axios from "axios";
import { URL } from "../../constants/insurance/constant.js";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    LineElement,
    Tooltip,
    Legend,
    Title
} from "chart.js";
ChartJS.register(CategoryScale, LinearScale, LineElement, Tooltip, Legend, Title);

const StatusWiseChart = ({ setShowBarTable, setShowTable, showTable, setShowTable1, showTable1 ,redirectToHistory}) => {
    const [clickedDatasetLabel, setClickedDatasetLabel] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [lineChartData, setLineChartData] = useState(null);
    const [selectedData, setSelectedData] = useState([]);
    const [apiData, setApiData] = useState([]);
    const tableRef = useRef(null);
    let erIds;
    try {
        const storedData = localStorage.getItem("erIDs");
        erIds = storedData ? JSON.parse(storedData) : [];
    } catch {
        erIds = [];
    }
    const fetchData = async () => {
        try {
            const response = await axios.post(
                `${URL.fuser_url}api/v1/request/generic/getESalesCasesConversion/raw`,
                { erIds },
                { headers: { "Content-Type": "application/json" } }
            );
            if (response.data && response.data.data) {
                setApiData(response.data.data);
                const categorizedData = processData(response.data.data);
                setLineChartData(formatLineChartData(categorizedData));
            }
        } catch (err) {
            console.error("Error fetching API data:", err);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    const processData = (data) => {
        const categorized = {};
        data.sort((a, b) => new Date(a.Date) - new Date(b.Date));
        data.forEach(item => {
            const date = item.Date;
            if (!categorized[date]) {
                categorized[date] = {
                    Appointment_Booked: 0,
                    Appointment_Rescheduled: 0,
                    Attended: 0,
                    Not_Attended: 0,
                    Reports_Uploaded: 0,
                    Cancelled: 0,
                    QC_Approved: 0
                };
            }
            if ([22, 23, 24, 25, 129, 40].includes(item.status_id)) {
                categorized[date].Appointment_Booked += 1;
            } else if ([29, 30, 31, 117].includes(item.status_id)) {
                categorized[date].Appointment_Rescheduled += 1;
            } else if (item.status_id === 32) {
                categorized[date].Attended += 1;
            } else if (item.status_id === 39) {
                categorized[date].Not_Attended += 1;
            } else if ([33, 37, 134].includes(item.status_id)) {
                categorized[date].Reports_Uploaded += 1;
            } else if ([27, 43, 119, 120].includes(item.status_id)) {
                categorized[date].Cancelled += 1;
            } else if (item.status_id === 48 && item.status_id!=0) {
                categorized[date].QC_Approved += 1;
            }
        });
        return categorized;
    };

    const formatLineChartData = (data) => {
        const labels = Object.keys(data);
        const appointmentBooked = labels.map(label => data[label].Appointment_Booked);
        const appointmentRescheduled = labels.map(label => data[label].Appointment_Rescheduled);
        const attended = labels.map(label => data[label].Attended);
        const notAttended = labels.map(label => data[label].Not_Attended);
        const reportsUploaded = labels.map(label => data[label].Reports_Uploaded);
        const cancelled = labels.map(label => data[label].Cancelled);
        const qcApproved = labels.map(label => data[label].QC_Approved);
        return {
            labels,
            datasets: [
                { label: "Appointment Booked", data: appointmentBooked, borderColor: "#46A6EA", backgroundColor: "#46A6EA" },
                { label: "Appointment Rescheduled", data: appointmentRescheduled, borderColor: "#6AC48E", backgroundColor: "#6AC48E" },
                { label: "Attended", data: attended, borderColor: "#474A8A", backgroundColor: "#474A8A" },
                { label: "Not Attended", data: notAttended, borderColor: "#888888", backgroundColor: "#888888" },
                { label: "Reports Uploaded", data: reportsUploaded, borderColor: "#F68B5F", backgroundColor: "#F68B5F" },
                { label: "Cancelled", data: cancelled, borderColor: "#FF5733", backgroundColor: "#FF5733" },
                { label: "QC Approved", data: qcApproved, borderColor: "#FFC300", backgroundColor: "#FFC300" }
            ]
        };
    };

    const handleDownloadCSV = () => {
        const headers = ['Date', 'Insurer ID', 'Insurer Name', 'ESales ID', 'Request ID'];
        const csvContent = [
            headers.join(','),
            ...selectedData.map(item =>
                [item.Date, item.insurer_id, item.insurer_name, item.esale_id, item.request_id].join(',')
            )
        ].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'Esales Data.csv');
    };
    
    const handleLineClick = (elements) => {
        if (elements.length > 0) {
            const clickedIndex = elements[0].index;
            const clickedLabel = lineChartData.labels[clickedIndex];
            const datasetIndex = elements[0].datasetIndex;
            const datasetLabel = lineChartData.datasets[datasetIndex].label;
            let filteredData;
            switch (datasetLabel) {
                case 'Appointment Booked':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && [22, 23, 24, 25, 129, 40].includes(item.status_id)
                    );
                    break;
                case 'Appointment Rescheduled':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && [29, 30, 31, 117].includes(item.status_id)
                    );
                    break;
                case 'Attended':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.status_id === 32
                    );
                    break;
                case 'Not Attended':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.status_id === 39
                    );
                    break;
                case 'Reports Uploaded':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && [33, 37, 134].includes(item.status_id)
                    );
                    break;
                case 'Cancelled':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && [27, 43, 119, 120].includes(item.status_id)
                    );
                    break;
                case 'QC Approved':
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel && item.status_id === 48
                    );
                    break;
                default:
                    filteredData = apiData.filter(item =>
                        item.Date === clickedLabel
                    );
            }
            setClickedDatasetLabel(datasetLabel);
            setSelectedData(filteredData);
            setCurrentPage(1);
            setShowTable1(prev => {
                setShowTable(false);
                setShowBarTable(false);
                const newValue = !prev;
                if (newValue) {
                    setTimeout(() => {
                        tableRef.current?.scrollIntoView({ behavior: 'smooth' });
                    }, 50);
                }
                return newValue;
            });
        }
    };

    // Update the options object
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom", labels: {
                    font: {
                        weight: 'bold'
                    }
                },
                onHover: (event) => {
                    event.native.target.style.cursor = "pointer";
                }
            },
            title: { display: true }
        },
        scales: {
            x: {
                grid: { display: false }, title: {
                    display: true,
                    text: "Date",
                    font: {
                        size: 14,
                        weight: "bold"
                    }
                },
                ticks: {
                    font: {
                        weight: "bold"
                    }
                }
            },
            y: {
                beginAtZero: true, title: {
                    display: true,
                    text: "Count",
                    font: {
                        size: 14,
                        weight: "bold"
                    }
                },
                ticks: {
                    font: {
                        weight: "bold"
                    }
                }
            },
        },
        onHover: (event, chartElement) => {
            if (chartElement.length) {
                event.native.target.style.cursor = "pointer";
            } else {
                event.native.target.style.cursor = "default";
            }
        },
        onClick: (event, elements) => handleLineClick(elements)
    };

    return (
        <div style={{
            width: "100%",
            maxWidth: "100%",
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "left",
            fontFamily: 'Lexend Deca',
        }}>
            <h5 style={{ marginBottom: "10px", fontWeight: "bold",paddingLeft:'20px' }}>
                Appointment Status Wise Count
            </h5>
            <div style={{ height: "400px", width: "100%", maxWidth: "100vw" }}>
                {lineChartData ? <Line data={lineChartData} options={options} /> : <p>Loading chart...</p>}
            </div>

            {/*table data*/}
            <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}></div>
            {showTable1 && (
                <div ref={tableRef} style={{
                    margin: '20px 0',
                    position: 'relative',
                    fontFamily: 'Lexend Deca',
                    width: '100%'
                }}>
                    <h5>
                        <b>
                            {clickedDatasetLabel ? `${clickedDatasetLabel}: ${selectedData.length}` : `Count: ${selectedData.length}`}
                        </b>
                    </h5>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '0.8em',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        fontFamily: 'Lexend Deca'
                    }}>
                        <thead>
                            <tr style={{ backgroundColor: '#46A6EA', textAlign: "center" }}>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000', borderRadius: '8px 0 0 0' }}>Date</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>Insurer ID</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>Insurer Name</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000' }}>ESales ID</th>
                                <th style={{ padding: '8px', border: '1px solid #ddd', color: '#000', borderRadius: '0 8px 0 0' }}>Request ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedData
                                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                                .map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: 'white', color: '#000', textAlign: 'center' }}>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 0 8px' }}>
                                            {new Date(item.Date).toLocaleDateString()}
                                        </td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.insurer_id}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.insurer_name}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 8px 0' }}>{item.esale_id}</td>
                                        <td style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '0 0 0 8px' }}>
                                        {item.request_id ? (
                                        <span style={{ color: 'blue', cursor: 'pointer' }} onClick={(e) => redirectToHistory(e, item.request_id)}>
                                        {item.request_id}</span>) : ( "-" )}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    <div style={{
                        position: 'absolute',
                        right: '0',
                        padding: '5px 10px',
                        fontWeight: 'bold',
                        fontSize: '0.9em',
                        color: '#000',
                    }}>
                        Showing {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, selectedData.length)} of {selectedData.length}
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '10px 0',
                        gap: '10px'
                    }}>
                        <button
                            onClick={handleDownloadCSV}
                            style={{
                                padding: '0px 10px',
                                backgroundColor: '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                fontFamily: 'Lexend Deca',
                                borderRadius: '3px',
                                cursor: 'pointer'
                            }}  >
                            Export ⬇
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            disabled={currentPage === 1}
                            style={{
                                padding: '0px 10px',
                                backgroundColor: currentPage === 1 ? '#ccc' : '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '3px',
                                fontFamily: 'Lexend Deca',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}   >
                            Previous
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => prev + 1)}
                            disabled={currentPage * itemsPerPage >= selectedData.length}
                            style={{
                                padding: '0px 25px',
                                backgroundColor: currentPage * itemsPerPage >= selectedData.length ? '#ccc' : '#46A6EA',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '3px',
                                fontFamily: 'Lexend Deca',
                                cursor: currentPage * itemsPerPage >= selectedData.length ? 'not-allowed' : 'pointer'
                            }}> Next
                        </button>
                    </div>
                    <div style={{ height: '2px', backgroundColor: '#888888', margin: '20px 0' }}></div>
                </div>
            )}
        </div>
    );
};

export default StatusWiseChart;
